import { init as Store } from '@vezham/ui/dist/contracts/hooks/useVStore'

import './index.css'
import { onIAMmessenge } from './utils/iam'

window.onmessage = onIAMmessenge
Store({ pretext: 'iam' })
